// src/Components/ScrollToTopButton.js
import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth animation
    });
  };

  return (
    <>
      {isVisible && (
        <button
  onClick={scrollToTop}
  className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 
             bg-orange-500 text-white p-2 sm:p-2 md:p-2
             rounded-full shadow-lg 
             hover:bg-orange-600 transition-all 
             z-50 flex items-center justify-center"
  aria-label="Scroll to Top"
>
  <svg
    className="w-6 h-6 sm:w-5 sm:h-5 md:w-10 md:h-10 text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m16 17-4-4-4 4m8-6-4-4-4 4"
    />
  </svg>
</button>

      )}
    </>
  );
};

export default ScrollToTopButton;
